export default {
  items: state => state.items,
  newKey: state => state.newKey,
  loading: state => state.loading,
};
